import React from 'react';
import PropTypes from 'prop-types';

export const TextCell = ({ value }) => <span style={{ textTransform: 'capitalize' }}>{value}</span>;

TextCell.propTypes = {
  value: PropTypes.node,
};
